module.exports = __webpack_public_path__ + "static/media/compare_94.c06c9f4d.svg";